import { computed, createBlock, openBlock, unref, withCtx, renderSlot, createElementVNode } from "vue";
import { VALIDATION_MESSAGE_TYPES, DtInput } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
const _hoisted_1 = { class: "d-input__label-text d-label--sm" };
const __default__ = {
  name: "DtcControlString"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: String,
      default: () => String()
    },
    disabled: {
      type: Boolean,
      default: false
    },
    warning: {
      type: String,
      default: void 0
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const messages = computed(() => {
      const messages2 = [];
      if (props.warning) {
        messages2.push({
          message: props.warning,
          type: VALIDATION_MESSAGE_TYPES.WARNING
        });
      }
      return messages2;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DtInput), {
        value: __props.value,
        disabled: __props.disabled,
        messages: messages.value,
        size: "sm",
        onInput: _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), e))
      }, {
        labelSlot: withCtx(() => [
          createElementVNode("span", _hoisted_1, [
            renderSlot(_ctx.$slots, "default")
          ])
        ]),
        rightIcon: withCtx(() => [
          renderSlot(_ctx.$slots, "icon")
        ]),
        _: 3
      }, 8, ["value", "disabled", "messages"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_string.vue.js.map
